import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import './styles.css';
import strings from '../../../../../globalization';
import { withRouter } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import Select from 'react-select';
import PermitsHeader from '../../../../../components/PermitsHeader';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import dimensions from '../../../../../util/dimensions-util';
import TextInput from '../../../../../components/TextInput';
import Button from '../../../../../components/Button';
import SannaLogo from '../../../../../components/SannaLogo';

const { vw: widthConstant, vh: heightConstant } = dimensions;

const Desktop = props => {
  const {
    onClick,
    onChange,
    selectedSearchKey,
    selectedType,
    transactions,
    searchText,
    roleId,
  } = props;

  const tabs = [
    {
      label: 'Users',
      id: 1,
      route: 'usage-management',
    },
  ];

  const searchKeyOptions = [
    { label: 'Payment ID', value: 'paymentId' },
    { label: 'Order ID', value: 'orderId' },
    { label: 'Reference ID', value: 'referenceId' },
  ];

  const typeOptions = [
    { label: 'Person', value: 'person' },
    { label: 'Vehicle', value: 'vehicle' },
  ];

  const columnDefs = [
    {
      headerName: 'Order Id',
      field: 'orderId',
      headerClass: styles.rowHeader,
      width: 250 * widthConstant,
      resizable: true,
      autoHeight: true,
      sortable: false,
      wrapText: true,
      cellStyle: { lineHeight: 1.5 },
      cellRendererFramework: ({ data: { orderId } }) => {
        return <div className={styles.sessionTime}>{orderId}</div>;
      },
    },
    {
      headerName: 'Payment Id',
      field: 'paymentId',
      headerClass: styles.rowHeader,
      width: 210 * widthConstant,
      resizable: true,
      sortable: false,
      autoHeight: true,
      cellRendererFramework: ({ data: { paymentId } }) => {
        return <div className={styles.sessionTime}>{paymentId}</div>;
      },
    },
    {
      headerName: 'Amount',
      field: 'amount',
      headerClass: styles.rowHeader,
      width: 150 * widthConstant,
      resizable: true,
      autoHeight: true,
      wrapText: true,
      cellRendererFramework: ({ data: { amount } }) => {
        return <div className={styles.sessionTime}>{amount}</div>;
      },
    },
    {
      headerName: 'Reference Id',
      field: 'referenceId',
      headerClass: styles.rowHeader,
      width: 150 * widthConstant,
      resizable: true,
      autoHeight: true,
      wrapText: true,
      cellRendererFramework: ({ data: { referenceId } }) => {
        return <div className={styles.sessionTime}>{referenceId}</div>;
      },
    },
    {
      headerName: 'Razorpay Payment Status',
      field: 'razorpayStatus',
      headerClass: styles.rowHeader,
      width: 250 * widthConstant,
      flex: 1,
      resizable: true,
      sortable: false,
      cellRendererFramework: ({ data: { razorpayStatus } }) => {
        return (
          <div className={styles.sessionTime}>
            {razorpayStatus}
          </div>
        );
      },
    },
    {
      headerName: 'Status',
      field: 'status',
      headerClass: styles.rowHeader,
      width: 120 * widthConstant,
      resizable: true,
      sortable: false,
      flex: 1,
      cellRendererFramework: ({ data: { status } }) => {
        return (
          <div className={styles.sessionTime}>
            {status}
          </div>
        );
      },
    },
  ];

  const [gridApi, setGridApi] = useState(null);

  useEffect(() => {
    if (gridApi && transactions && transactions.length > 10) {
      gridApi.setDomLayout('normal');
    } else if (gridApi) {
      gridApi.setDomLayout('autoHeight');
    }
  }, [gridApi, transactions]);

  const onGridReady = params => {
    setGridApi(params.api);
  };

  const onCellClick = (event, index) => {
    onClick('rowClick', event.data);
  };

  const rowStyle = { border: 'none', cursor: 'pointer' };
  const getRowStyle = params => {
    if (params.node.rowIndex % 2 === 0) {
      return { background: '#f6f6f6', border: 'none' };
    }
  };

  const handleClear = () => {
    onClick('clearFilters');
  };

  const handleSearchKeyChange = selectedOption => {
    onChange('onSearchKeyChange', selectedOption?.value);
  };

  const handleTypeChange = selectedOption => {
    onChange('onTypeChange', selectedOption?.value);
  };

  const selectedSearchKeyValue =
    searchKeyOptions.find(opt => opt.value === selectedSearchKey) ||
    searchKeyOptions[0];

  const selectedTypeValue =
    typeOptions.find(opt => opt.value === selectedType) || typeOptions[0];

  const onTabClick = id => {
    switch (id) {
      case 1:
        break;
      default:
        break;
    }
  };

  return (
    <div>
      <PermitsHeader
        title="Person / Vehicle Transactions"
        onTabClick={onTabClick}
      />
      <div className={styles.bodyContainer}>
        <div className={styles.header}>
          <div className={styles.left}>
            {/* Person / Vehicle Dropdown */}
            <div className={styles.dropdownWrapper}>
              <Select
                options={typeOptions}
                value={selectedTypeValue}
                onChange={handleTypeChange}
                placeholder="Select Type"
                className={styles.selectDropdown}
              />
            </div>

            {/* Search Key Dropdown */}
            <div className={styles.dropdownWrapper}>
              <Select
                options={searchKeyOptions}
                value={selectedSearchKeyValue}
                onChange={handleSearchKeyChange}
                placeholder="Select ID Type"
                className={styles.selectDropdown}
              />
            </div>

            {/* Search Box */}
            <div>
              <TextInput
                placeholder="enter paymentID or referenceID or orderID"
                value={(searchText || '').slice(0, 50)}
                onChange={value =>
                  onChange('search', (value || '').toString().slice(0, 50))
                }
                inputStyle={styles.searchBox}
                isEdit={true}
              />
            </div>
          </div>

          <div className={styles.right}>

            <Button
              onClick={() => onClick('fetchTransactions')}
              buttonStyle="primary"
              label="Fetch Transactions"
              className={styles.applyBtn}
            />
          </div>
        </div>

        <div
          className={[
            'ag-theme-balham',
            styles.tableWrapper,
            transactions?.length > 10
              ? styles.tableWrapperNormal
              : styles.tableWrapperAutoHeight,
          ].join(' ')}
        >
          <AgGridReact
            onGridReady={onGridReady}
            rowStyle={rowStyle}
            getRowStyle={getRowStyle}
            rowHoverHighlight={true}
            columnDefs={columnDefs}
            rowHeight={50 * heightConstant}
            headerHeight={50 * heightConstant}
            defaultColDef={{ sortable: true }}
            rowClass={[styles.gridRowClass]}
            pagination={true}
            paginationPageSize={100}
            onCellClicked={(event, index) => onCellClick(event, index)}
            rowData={transactions}
            domLayout="normal"
          />
        </div>
        <div className={styles.bottomLabel}>
          Showing {transactions ? transactions.length : 0}
        </div>
      </div>
      <div className={styles.SannaLogo}>
        <SannaLogo />
      </div>
    </div>
  );
};

export default withRouter(Desktop);

